import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initSentry } from './config/sentry';

initSentry();

// 環境に応じてtitleタグにプレフィックスを付与（初期表示用）
// 各ページで useDocumentTitle フックにより上書きされる
const hostname = window.location.hostname;
const getEnvironmentPrefix = (): string => {
  if (hostname === 'localhost') return '【localhost】';
  if (hostname.startsWith('dev-nft.')) return '【Dev】';
  if (hostname.startsWith('demo-nft.')) return '【Demo】';
  return '';
};
const baseTitle = 'RunPort NFT - マラソン完走証をブロックチェーンに刻む';
document.title = getEnvironmentPrefix() + baseTitle;

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
